"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalPortal = exports.modalRoot = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_dom_1 = require("react-dom");
var ModalPortal = /** @class */ (function (_super) {
    tslib_1.__extends(ModalPortal, _super);
    function ModalPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.element = document.createElement('div');
        if (!exports.modalRoot) {
            exports.modalRoot = document.createElement('div');
            exports.modalRoot.id = 'modal-root';
            document.body.insertBefore(exports.modalRoot, document.getElementById('app-root'));
        }
        return _this;
    }
    ModalPortal.prototype.componentDidMount = function () {
        // The portal element is inserted in the DOM tree after
        // the Modal's children are mounted, meaning that children
        // will be mounted on a detached DOM node. If a child
        // component requires to be attached to the DOM tree
        // immediately when mounted, for example to measure a
        // DOM node, or uses 'autoFocus' in a descendant, add
        // state to Modal and only render the children when Modal
        // is inserted in the DOM tree.
        exports.modalRoot.appendChild(this.element);
    };
    ModalPortal.prototype.componentWillUnmount = function () {
        exports.modalRoot.removeChild(this.element);
    };
    ModalPortal.prototype.render = function () {
        return react_dom_1.createPortal(this.props.children, this.element);
    };
    return ModalPortal;
}(react_1.Component));
exports.ModalPortal = ModalPortal;
//# sourceMappingURL=ModalPortal.js.map